import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/** Delay between digits; with ~2.7s strip duration, 3-digit totals land near 3s */
const STAGGER_SEC = 0.15;

/** When the section top crosses this line of the viewport, odometer runs once (lower % = later, more scrolled). */
const SCROLL_TRIGGER_START = "top 60%";

function buildOdometerFragment(text) {
  const frag = document.createDocumentFragment();
  let digitIndex = 0;

  for (const ch of text) {
    if (ch >= "0" && ch <= "9") {
      const n = Number(ch);
      const digit = document.createElement("span");
      digit.className = "odometer__digit";
      digit.style.setProperty("--digit", String(n));

      const strip = document.createElement("span");
      strip.className = "odometer__strip";
      strip.style.transitionDelay = `${digitIndex * STAGGER_SEC}s`;
      digitIndex += 1;

      for (let i = 0; i <= 9; i += 1) {
        const sym = document.createElement("span");
        sym.className = "odometer__sym";
        sym.textContent = String(i);
        strip.appendChild(sym);
      }

      digit.appendChild(strip);
      frag.appendChild(digit);
    } else {
      const sep = document.createElement("span");
      sep.className = "odometer__sep";
      sep.textContent = ch;
      frag.appendChild(sep);
    }
  }

  return frag;
}

/**
 * Slot-style digits (SCSS). ScrollTrigger adds `figures--odometer-active` once in view.
 */
export function initFiguresOdometer() {
  const section = document.querySelector('.figures[data-animate="odometer"]');
  if (!section) return;

  const numberSpans = section.querySelectorAll(".figures__value-number");
  if (!numberSpans.length) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  for (const span of numberSpans) {
    const raw = span.textContent.trim();
    span.textContent = "";
    span.classList.add("odometer");
    span.appendChild(buildOdometerFragment(raw));
  }

  ScrollTrigger.refresh();

  ScrollTrigger.create({
    trigger: section,
    start: SCROLL_TRIGGER_START,
    once: true,
    onEnter: () => {
      section.classList.add("figures--odometer-active");
    },
  });
}
